export const COMPETITORS_COLORS = [
  '#EC3793',
  '#3574FF',
  '#F08B00',
  '#891EFA',
  '#009AAE',
  '#E94E77',
  '#669CFF',
  '#FFBC54',
  '#B377FA',
  '#2FD6FF',
  '#A32C74',
  '#002A77',
  '#B15C00',
  '#661AAD',
  '#016D84',
  '#FF6FBE',
  '#90C2FF',
  '#FFF2B4',
  '#CBB6F8',
  '#58E6FF',
];
